"use strict";
/* eslint-disable import/prefer-default-export */
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSnakeCase = void 0;
const toSnakeCase = (str) => {
    if (!str)
        return undefined;
    return (str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g) || [])
        .map((x) => x.toLowerCase())
        .join('_');
};
exports.toSnakeCase = toSnakeCase;
//# sourceMappingURL=utils.js.map